import { render } from "./Sidebar.vue?vue&type=template&id=a5d63972&scoped=true"
const script = {}

import "./Sidebar.vue?vue&type=style&index=0&id=a5d63972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d63972"]])

export default __exports__